"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTooltipLabelValue = void 0;
const react_1 = __importDefault(require("react"));
const list_1 = require("./list");
function ChartTooltipLabelValue(args) {
    const { title, values } = args;
    const [value] = values || [];
    const { label } = value || {};
    return (0, list_1.ChartTooltipList)(Object.assign(Object.assign({}, args), { title: label, values: [Object.assign(Object.assign({}, value), { label: react_1.default.createElement(react_1.default.Fragment, null, title) })] }));
}
exports.ChartTooltipLabelValue = ChartTooltipLabelValue;
//# sourceMappingURL=label-value.js.map